import { css } from '@emotion/css';

const styles = {
  productTile: css`
    && > div:last-child {
      height: 100%;
      padding: var(--spacing-300);
      border-radius: var(--border-radius-400);

      @media (max-width: 668px) {
        padding: var(--spacing-400) var(--spacing-200) var(--spacing-200);
      }
    }

    &&:has(input:checked) > div:last-child {
      border-color: var(--color-border-brand);
      box-shadow: inset 0 0 0 1px var(--color-border-brand);
    }

    && input {
      border-color: var(--color-border-default);

      &:checked {
        border-color: var(--color-border-brand);

        &::after {
          background: var(--color-background-brand);
        }
      }
    }

    && div:has(> input[type='radio']) {
      @media (max-width: 668px) {
        display: none;
      }
    }

    /* ProductSelectionCard has no className prop for its discount row.
       Target the wrapper through our badge hook instead of its generated class. */
    && div:has(> span > [data-adac-discount]) {
      align-items: flex-start;
      flex-direction: column;
      gap: var(--spacing-200);
      margin-top: var(--spacing-200);
      color: var(--color-text-weak);

      @media (max-width: 668px) {
        align-items: center;
        flex-direction: row;
        flex-wrap: nowrap;
        gap: var(--spacing-100);
        white-space: nowrap;
      }
    }

    && [class*='price-container'] > span:last-child {
      font-size: var(--size-body-small);
      color: var(--color-text-weak);
    }

    && [class*='font-strike'] {
      font-size: var(--size-body-small);
      color: var(--color-text-weak);
    }

    && [class*='product-selection-card-label'] {
      @media (max-width: 668px) {
        right: var(--spacing-100);
        max-width: calc(100% - 2 * var(--spacing-100));
      }
    }
  `,
  discountBadge: css`
    display: inline-block;
    padding: var(--spacing-100) var(--spacing-200);
    border-radius: var(--border-radius-rounded);
    background: var(--color-background-brand);
    color: var(--color-text-default);
    font-weight: 700;
    font-size: var(--size-body-small);
  `,
  savingsBadge: css`
    display: inline-block;
    padding: var(--spacing-100) var(--spacing-200);
    border-radius: var(--border-radius-100);
    background: var(--color-background-warning-weak);
    color: var(--color-text-default);
    font-weight: 700;
    @media (max-width: 668px) {
      padding: var(--spacing-100);
      font-size: var(--size-body-small);
      line-height: var(--line-height-body-small);
      text-align: center;
    }
  `,
};

export default styles;
